import React from 'react';
import { Link } from 'react-router-dom';
import { toolTypeLabel } from '../../../utils/billToFlowTools';

function StepToolCreated({ wizardData, onReset }) {
  const now = new Date();
  const createdOn = now.toLocaleString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });

  return (
    <div className="flex flex-col items-center py-8">
      <div className="flex h-20 w-20 items-center justify-center rounded-full bg-emerald-100">
        <svg className="h-10 w-10 text-emerald-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="20 6 9 17 4 12" />
        </svg>
      </div>

      <h2 className="mt-5 text-xl font-bold text-gray-900">Tool Created Successfully!</h2>
      <p className="mt-1 text-sm text-gray-500">
        Your projected ordering tool has been created and is ready to use.
      </p>

      <div className="mt-8 w-full max-w-lg rounded-xl border border-gray-200 bg-white">
        <table className="w-full text-sm">
          <tbody>
            {[
              ['Tool Name', wizardData.toolName || '—'],
              ['Tool Code', wizardData.toolCode || 'Auto-generated'],
              ['Tool Type', toolTypeLabel(wizardData)],
              ['Outlet', wizardData.outletName || '—'],
              ['Created On', createdOn],
              ['Created By', wizardData.createdBy || '—'],
            ].map(([label, value], idx) => (
              <tr key={label} className={idx > 0 ? 'border-t border-gray-100' : ''}>
                <td className="px-5 py-3 font-medium text-gray-500">{label}</td>
                <td className="px-5 py-3 text-gray-900">{value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/dashboard/admin/build-to-flow"
          className="inline-flex items-center justify-center rounded-lg border border-gray-200 bg-white px-5 py-2.5 text-sm font-semibold text-gray-700 shadow-sm hover:bg-gray-50"
        >
          Go to My Tools
        </Link>
        <button
          type="button"
          onClick={onReset}
          className="inline-flex items-center justify-center rounded-lg border border-brand bg-white px-5 py-2.5 text-sm font-semibold text-brand shadow-sm hover:bg-brand/5"
        >
          Create Another Tool
        </button>
      </div>
    </div>
  );
}

export default StepToolCreated;
